<template>
  <div>
    <b-row>
      <b-col cols="12" class="mt-4">
        <b-form-group>
          <div style="display:flex;">
            <b-form-checkbox
              :disabled="searchPage"
              v-model="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.ageOfArticleObject.ageOfArticle"
            >Age Of Article&nbsp; &nbsp;</b-form-checkbox>
            <b-form-checkbox
              :disabled="searchPage"
              v-model="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.siteTypeObject.siteType"
            >Site Type&nbsp; &nbsp;</b-form-checkbox>
            <b-form-checkbox
              :disabled="searchPage"
              v-model="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.keywordCountObject.keywordCountTotal"
            >Keyword count total&nbsp; &nbsp;</b-form-checkbox>
            <b-form-checkbox
              :disabled="searchPage"
              v-model="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.nlpMatchObject.nlpMatch"
            >NLP Match&nbsp; &nbsp;</b-form-checkbox>
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <b-tabs vertical pills>
      <b-tab title="Weighting">
        <b-card>
          <b-row>
            <b-col cols="6">
              <b-table-simple class="table my-2">
                <b-thead>
                  <b-tr>
                    <b-th scope="col">Risk</b-th>
                    <b-th scope="col">From</b-th>
                    <b-th scope="col">To</b-th>
                  </b-tr>
                </b-thead>

                <b-tbody>
                  <b-tr>
                    <b-td>
                      <b-badge variant="success">Low</b-badge>
                    </b-td>
                    <b-td>1</b-td>
                    <b-td>
                      <b-form-input
                        :disabled="searchPage"
                        v-model="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.weighting.lowerUpperLimit"
                        onkeydown="return event.keyCode !== 69"
                        type="number"
                        max="30"
                        @input="onUpdateSumWeightingValues"
                      ></b-form-input>
                    </b-td>
                  </b-tr>

                  <b-tr>
                    <b-td>
                      <b-badge variant="warning">Medium</b-badge>
                    </b-td>
                    <b-td>{{$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.weighting.lowerUpperLimit ? parseInt($store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.weighting.lowerUpperLimit)+1 : 0}}</b-td>
                    <b-td>
                      <b-form-input
                        :disabled="searchPage"
                        onkeydown="return event.keyCode !== 69"
                        v-model="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.weighting.mediumUpperLimit"
                        type="number"
                        min="31"
                        max="75"
                        @input="onUpdateSumWeightingValues"
                      ></b-form-input>
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-td>
                      <b-badge variant="danger">High</b-badge>
                    </b-td>
                    <b-td>{{$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.weighting.mediumUpperLimit ? parseInt($store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.weighting.mediumUpperLimit)+1 : 0}}</b-td>
                    <b-td></b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-col>
            <b-col cols="6">
              <h3>Scoring</h3>
              <b-table-simple class="table my-2">
                <b-thead>
                  <b-tr>
                    <b-th scope="col">Metric</b-th>

                    <b-th scope="col">weighting</b-th>
                  </b-tr>
                </b-thead>

                <b-tbody>
                  <b-tr
                    v-if="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.ageOfArticleObject.ageOfArticle"
                  >
                    <b-td>
                      <b-badge variant="success">Age of Article</b-badge>
                    </b-td>

                    <b-td>
                      <b-form-input
                        :disabled="searchPage"
                        v-model="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.weighting.ageOfArticleWeightingValue"
                        onkeydown="return event.keyCode !== 69"
                        type="number"
                        min="1"
                        max="100"
                        @input="onUpdateSumValues"
                      ></b-form-input>
                    </b-td>
                  </b-tr>

                  <b-tr
                    v-if="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.siteTypeObject.siteType"
                  >
                    <b-td>
                      <b-badge variant="warning">Site Type</b-badge>
                    </b-td>

                    <b-td>
                      <b-form-input
                        :disabled="searchPage"
                        onkeydown="return event.keyCode !== 69"
                        v-model="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.weighting.siteTypeWeightingValue"
                        type="number"
                        min="1"
                        max="100"
                        @input="onUpdateSumValues"
                      ></b-form-input>
                    </b-td>
                  </b-tr>
                  <b-tr
                    v-if="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.nlpMatchObject.nlpMatch"
                  >
                    <b-td>
                      <b-badge variant="danger">NLP Match</b-badge>
                    </b-td>

                    <b-td>
                      <b-form-input
                        :disabled="searchPage"
                        onkeydown="return event.keyCode !== 69"
                        v-model="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.weighting.nlpMatchWeightingValue"
                        type="number"
                        min="1"
                        max="100"
                        @input="onUpdateSumValues"
                      ></b-form-input>
                    </b-td>
                  </b-tr>
                  <b-tr
                    v-if="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.keywordCountObject.keywordCountTotal"
                  >
                    <b-td>
                      <b-badge variant="primary">Keyword count</b-badge>
                    </b-td>

                    <b-td>
                      <b-form-input
                        :disabled="searchPage"
                        onkeydown="return event.keyCode !== 69"
                        v-model="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.weighting.keywordCountTotalWeightingValue"
                        type="number"
                        min="1"
                        max="100"
                        @input="onUpdateSumValues"
                      ></b-form-input>
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-td>Total</b-td>
                    <b-td>
                      <b-form-group :invalid-feedback="showSumError">
                        <b-form-input
                          :disabled="searchPage"
                          :state="showSumError ? false : null"
                          type="number"
                          :value="totalSum"
                          readonly
                        ></b-form-input>
                      </b-form-group>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-col>
          </b-row>
        </b-card>
      </b-tab>
      <b-tab
        title="Age Of Article"
        v-if="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.ageOfArticleObject.ageOfArticle"
      >
        <b-table-simple class="table my-2">
          <b-thead>
            <b-tr>
              <b-th scope="col">From</b-th>
              <b-th scope="col">To</b-th>
              <b-th scope="col">Score</b-th>
              <b-th scope="col">Action</b-th>
            </b-tr>
          </b-thead>

          <b-tbody>
            <b-tr v-for="(cloenFields,index) in ageOfArticleInput" :key="index">
              <b-td>{{parseInt(cloenFields)+1}}</b-td>
              <b-td>
                <b-form-input
                  :disabled="searchPage"
                  v-model="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.ageOfArticleObject.ageOfArticleToValue[index]"
                  onkeydown="return event.keyCode !== 69"
                  @change="setArrayValue($event)"
                  type="number"
                  max="30"
                ></b-form-input>
              </b-td>
              <b-td>
                <b-form-input
                  :disabled="searchPage"
                  onkeydown="return event.keyCode !== 69"
                  v-model="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.ageOfArticleObject.ageOfArticleScoreValue[index]"
                  type="number"
                  min="31"
                  max="75"
                ></b-form-input>
              </b-td>
              <b-td>
                <b-button
                  variant="outline-danger"
                  v-if="index > 0"
                  :disabled="searchPage"
                  class="btn btn-outline-danger btn-sm"
                  @click="onDeleteOption(index)"
                >
                  <i class="fa fa-trash"></i>
                </b-button>
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>
                <b-button :disabled="searchPage" @click="addRowInAgeOfArticle">Add Row</b-button>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-tab>
      <b-tab
        title="Site Type"
        v-if="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.siteTypeObject.siteType"
      >
        <b-table-simple class="table my-2">
          <b-thead>
            <b-tr>
              <b-th scope="col">Site Type</b-th>

              <b-th scope="col">Score</b-th>
            </b-tr>
          </b-thead>

          <b-tbody>
            <b-tr>
              <b-td>Local</b-td>

              <b-td>
                <b-form-input
                  :disabled="searchPage"
                  onkeydown="return event.keyCode !== 69"
                  v-model="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.siteTypeObject.localSiteType"
                  type="number"
                  min="31"
                  max="75"
                ></b-form-input>
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>Regional</b-td>

              <b-td>
                <b-form-input
                  :disabled="searchPage"
                  onkeydown="return event.keyCode !== 69"
                  v-model="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.siteTypeObject.regionalSiteType"
                  type="number"
                  min="31"
                  max="75"
                ></b-form-input>
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>Global</b-td>

              <b-td>
                <b-form-input
                  :disabled="searchPage"
                  onkeydown="return event.keyCode !== 69"
                  v-model="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.siteTypeObject.globalSiteType"
                  type="number"
                  min="31"
                  max="75"
                ></b-form-input>
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>Unkown</b-td>

              <b-td>
                <b-form-input
                  :disabled="searchPage"
                  onkeydown="return event.keyCode !== 69"
                  v-model="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.siteTypeObject.unkownSiteType"
                  type="number"
                  min="31"
                  max="75"
                ></b-form-input>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-tab>
      <b-tab
        title="NLP Match"
        v-if="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.nlpMatchObject.nlpMatch"
      >
        <b-table-simple class="table my-2">
          <b-thead>
            <b-tr>
              <b-th scope="col">&nbsp;</b-th>

              <b-th scope="col">Score</b-th>
            </b-tr>
          </b-thead>

          <b-tbody>
            <b-tr>
              <b-td>Match</b-td>

              <b-td>
                <b-form-input
                  v-model="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.nlpMatchObject.matchNlpValue"
                  type="number"
                  :disabled="searchPage"
                  min="1"
                  max="100"
                ></b-form-input>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-tab>
      <b-tab
        title="Keyword Match Count"
        v-if="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.keywordCountObject.keywordCountTotal"
      >
        <b-table-simple class="table my-2">
          <b-thead>
            <b-tr>
              <b-th scope="col">Risk</b-th>
              <b-th scope="col">From</b-th>
              <b-th scope="col">To</b-th>
            </b-tr>
          </b-thead>

          <b-tbody>
            <b-tr>
              <b-td>
                <b-badge variant="success">Low</b-badge>
              </b-td>
              <b-td>1</b-td>
              <b-td>
                <b-form-input
                  :disabled="searchPage"
                  v-model="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.keywordCountObject.lowerUpperLimit"
                  onkeydown="return event.keyCode !== 69"
                  type="number"
                  max="30"
                ></b-form-input>
              </b-td>
            </b-tr>

            <b-tr>
              <b-td>
                <b-badge variant="warning">Medium</b-badge>
              </b-td>
              <b-td>{{$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.keywordCountObject.lowerUpperLimit ? parseInt($store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.keywordCountObject.lowerUpperLimit)+1 : 0}}</b-td>
              <b-td>
                <b-form-input
                  :disabled="searchPage"
                  onkeydown="return event.keyCode !== 69"
                  v-model="$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.keywordCountObject.mediumUpperLimit"
                  type="number"
                  min="31"
                  max="75"
                ></b-form-input>
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>
                <b-badge variant="danger">High</b-badge>
              </b-td>
              <b-td>{{$store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.keywordCountObject.mediumUpperLimit ? parseInt($store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].scoring.keywordCountObject.mediumUpperLimit)+1 : 0}}</b-td>
              <b-td></b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
export default {
  name: "ScoringComponent",
  data() {
    return {
      ageOfArticleToValue: [],
      ageOfArticleScoreValue: [],
      totalSum: null,
      sumValues: [],
      showSumError: null,
      ageOfArticleInput: [0],
      setInputArray: [],
      inputValue: null,
      totalSumWeighting: null,
      showSumErrorWeighting: null
    };
  },
  mounted() {
    this.onUpdateSumValues();
    if (
      this.$store.state.priConfigrationforms.negativeMedia.categories[
        this.categoriesIndex
      ].scoring.ageOfArticleObject.ageOfArticleToValue.length
    ) {
      this.$store.state.priConfigrationforms.negativeMedia.categories[
        this.categoriesIndex
      ].scoring.ageOfArticleObject.ageOfArticleToValue.map(data => {
        this.ageOfArticleInput.push(data);
      });
    }
  },
  methods: {
    setArrayValue(data) {
      this.setInputArray.push(data);
    },
    addRowInAgeOfArticle() {
      if (this.setInputArray.length > 0) {
        this.setInputArray.map(data => {
          this.$store.state.priConfigrationforms.negativeMedia.categories[
            this.categoriesIndex
          ].scoring.ageOfArticleObject.ageOfArticleToValue.push(
            parseInt(data) + 2
          );
          this.ageOfArticleInput.push(data);
          this.inputValue = data;
        });
        this.setInputArray = [];
      } else {
        this.ageOfArticleInput.push(
          this.inputValue != null ? parseInt(this.inputValue) + 2 : null
        );
        this.inputValue = null;
      }
    },
    onDeleteOption(index) {
      this.$store.state.priConfigrationforms.negativeMedia.categories[
        this.categoriesIndex
      ].scoring.ageOfArticleObject.ageOfArticleToValue.splice(index, 1);
      this.$store.state.priConfigrationforms.negativeMedia.categories[
        this.categoriesIndex
      ].scoring.ageOfArticleObject.ageOfArticleScoreValue.splice(index, 1);
    },
    onUpdateSumValues() {
      this.getSumOfAllValues();
    },

    getSumOfAllValues() {
      let ageOfArticleNumber = this.$store.state.priConfigrationforms
        .negativeMedia.categories[this.categoriesIndex].scoring.weighting
        .ageOfArticleWeightingValue
        ? parseInt(
            this.$store.state.priConfigrationforms.negativeMedia.categories[
              this.categoriesIndex
            ].scoring.weighting.ageOfArticleWeightingValue
          )
        : 0;
      let siteTypeNumber = this.$store.state.priConfigrationforms.negativeMedia
        .categories[this.categoriesIndex].scoring.weighting
        .siteTypeWeightingValue
        ? parseInt(
            this.$store.state.priConfigrationforms.negativeMedia.categories[
              this.categoriesIndex
            ].scoring.weighting.siteTypeWeightingValue
          )
        : 0;
      let nlpMatchNumber = this.$store.state.priConfigrationforms.negativeMedia
        .categories[this.categoriesIndex].scoring.weighting
        .nlpMatchWeightingValue
        ? parseInt(
            this.$store.state.priConfigrationforms.negativeMedia.categories[
              this.categoriesIndex
            ].scoring.weighting.nlpMatchWeightingValue
          )
        : 0;
      let keywordCountTotalNumber = this.$store.state.priConfigrationforms
        .negativeMedia.categories[this.categoriesIndex].scoring.weighting
        .keywordCountTotalWeightingValue
        ? parseInt(
            this.$store.state.priConfigrationforms.negativeMedia.categories[
              this.categoriesIndex
            ].scoring.weighting.keywordCountTotalWeightingValue
          )
        : 0;

      let setAgeOfArticleWeightingValue = this.$store.state.priConfigrationforms
        .negativeMedia.categories[this.categoriesIndex].scoring
        .ageOfArticleObject.ageOfArticle
        ? ageOfArticleNumber
        : 0;
      let setSiteTypeWeightingValue = this.$store.state.priConfigrationforms
        .negativeMedia.categories[this.categoriesIndex].scoring.siteTypeObject
        .siteType
        ? siteTypeNumber
        : 0;
      let setNlpMatchWeightingValue = this.$store.state.priConfigrationforms
        .negativeMedia.categories[this.categoriesIndex].scoring.nlpMatchObject
        .nlpMatch
        ? nlpMatchNumber
        : 0;
      let setKeywordCountTotalWeightingValue = this.$store.state
        .priConfigrationforms.negativeMedia.categories[this.categoriesIndex]
        .scoring.keywordCountObject.keywordCountTotal
        ? keywordCountTotalNumber
        : 0;

      let sumOfAllValues =
        setAgeOfArticleWeightingValue +
        setSiteTypeWeightingValue +
        setNlpMatchWeightingValue +
        setKeywordCountTotalWeightingValue;

      if (sumOfAllValues > 100) {
        this.showSumError = "This value cannot be grater than 100";
        this.totalSum = sumOfAllValues;
      } else {
        this.showSumError = null;
        this.totalSum = sumOfAllValues;
      }
    },
    onUpdateSumWeightingValues() {
      let lowerUpperLimitNumber = this.$store.state.priConfigrationforms
        .negativeMedia.categories[this.categoriesIndex].scoring.weighting
        .lowerUpperLimit
        ? parseInt(
            this.$store.state.priConfigrationforms.negativeMedia.categories[
              this.categoriesIndex
            ].scoring.weighting.lowerUpperLimit
          )
        : 0;
      let setLowerUpperLimitNumber = this.$store.state.priConfigrationforms
        .negativeMedia.categories[this.categoriesIndex].scoring.weighting
        .lowerUpperLimit
        ? lowerUpperLimitNumber
        : 0;

      let mediumUpperLimitNumber = this.$store.state.priConfigrationforms
        .negativeMedia.categories[this.categoriesIndex].scoring.weighting
        .mediumUpperLimit
        ? parseInt(
            this.$store.state.priConfigrationforms.negativeMedia.categories[
              this.categoriesIndex
            ].scoring.weighting.mediumUpperLimit
          )
        : 0;
      let setMediumUpperLimitNumber = this.$store.state.priConfigrationforms
        .negativeMedia.categories[this.categoriesIndex].scoring.weighting
        .mediumUpperLimit
        ? mediumUpperLimitNumber
        : 0;

      let sumOfAllValues = setLowerUpperLimitNumber + setMediumUpperLimitNumber;

      if (sumOfAllValues > 100) {
        this.showSumErrorWeighting = "This value cannot be grater than 100";
        this.totalSumWeighting = sumOfAllValues;
      } else {
        this.showSumErrorWeighting = null;
        this.totalSumWeighting = sumOfAllValues;
      }
    }
  },
  props: {
    futureRiskTab: Boolean,
    negativeMediaTab: Boolean,
    categoriesIndex: Number,
    negativeMediaEdit: Boolean,
    futureRisksEdit: Boolean,
    searchPage: Boolean
  }
};
</script>
